import { render, staticRenderFns } from "./evaluation-view.vue?vue&type=template&id=31cd67b8&scoped=true"
import script from "./evaluation-view.vue?vue&type=script&lang=js"
export * from "./evaluation-view.vue?vue&type=script&lang=js"
import style0 from "./evaluation-view.vue?vue&type=style&index=0&id=31cd67b8&prod&lang=scss&scoped=true"
import style1 from "./evaluation-view.vue?vue&type=style&index=1&id=31cd67b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cd67b8",
  null
  
)

export default component.exports